import { useTranslation } from 'react-i18next';
import { useConfirmationContext } from '../../contexts/ConfirmationContext';
import AppModal from './Modal';

const ModalConfirmResetPassword = () => {
    const { t } = useTranslation();

    const {
        resetPasswordConfirmationText,
        setResetPasswordConfirmationText,
        setResetPasswordConfirmed,
    } = useConfirmationContext();

    const confirm = () => {
        setResetPasswordConfirmed(true);
        setResetPasswordConfirmationText(null);
    };

    const cancel = () => {
        setResetPasswordConfirmationText(null);
    };

    if (!resetPasswordConfirmationText) return <></>;

    return (
        <AppModal
            safeAction={cancel}
            safeText={t('button.no_cancel') as string}
            dangerAction={confirm}
            dangerText={t('button.yes_reset_password') as string}
            dangerCss="btn-warning"
        >
            <h3>{t('feedback.confirm_action')}</h3>
            <p>{resetPasswordConfirmationText}</p>
        </AppModal>
    );
};

export default ModalConfirmResetPassword;
